<script lang="ts" setup>
import { ArchiveBoxIcon, ChatBubbleLeftRightIcon, ClockIcon, ExclamationTriangleIcon, PencilSquareIcon } from '@heroicons/vue/24/outline';
import { Badge } from '@vue-interface/badge';
import { titleCase } from '../composables/titleCase';

withDefaults(defineProps<{
    send: { status: string };
    size?: 'sm'|'md'|'lg';
}>(), {
    size: 'md',
});
</script>

<template>
    <Badge
        v-if="send.status"
        :size="{
            'badge-xs': size === 'sm',
            'badge-md': size === 'md',
            'badge-lg': size === 'lg',
        }"
        :class="{
            'badge-neutral-500': send.status === 'draft',
            'badge-emerald-600': send.status === 'delivered',
            'badge-sky-600': send.status === 'queued',
            'badge-blue-800': send.status === 'scheduled',
            'badge-red-500': send.status === 'failed',
        }">
        <div class="gap-1 inline-flex items-center">
            <ChatBubbleLeftRightIcon
                v-if="send.status === 'delivered'"
                :class="{ 'w-3 h-3': size === 'sm', 'w-4 h-4': size === 'md', 'w-5 h-5': size === 'lg' }" />
            <ClockIcon
                v-if="send.status === 'scheduled'"
                :class="{ 'w-3 h-3': size === 'sm', 'w-4 h-4': size === 'md', 'w-5 h-5': size === 'lg' }" />
            <ArchiveBoxIcon
                v-if="send.status === 'queued'"
                :class="{ 'w-3 h-3': size === 'sm', 'w-4 h-4': size === 'md', 'w-5 h-5': size === 'lg' }" />
            <ExclamationTriangleIcon
                v-if="send.status === 'failed'"
                :class="{ 'w-3 h-3': size === 'sm', 'w-4 h-4': size === 'md', 'w-5 h-5': size === 'lg' }" />
            <PencilSquareIcon
                v-if="send.status === 'draft'"
                :class="{ 'w-3 h-3': size === 'sm', 'w-4 h-4': size === 'md', 'w-5 h-5': size === 'lg' }" />
            {{ titleCase(send.status) }}
        </div>
    </Badge>
</template>
